import type { InformationSectionIconProps } from "./information-section-icon.type";

import { WarningOutlined } from "@ant-design/icons";

import { IconCustom } from "@/ui/icon-custom";

export const InformationSectionIcon = ({
  type,
}: InformationSectionIconProps) => {
  if (type === "warning") return <WarningOutlined />;

  return <IconCustom type="info" />;
};
